import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db, functions } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import { connect } from 'react-redux';

// Components - imported
import Spinner from '../common/Spinner';
import GroupBlock from './GroupBlock';
import { getFollowingGroups_Helper } from '../../actions/groupActions';

const PAGE_SIZE = 5;

// Displays if the user is logged in AND has set up profile
const FollowingGroupsSection = ({ 
    auth: {
        user
    }
}) => {

    const [groupsData, setGroupsData] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);
    const [groupsList, setGroupsList] = useState([]);

    // Disable 'see more' users btn and show a loading state
    const [processing, setProcessing] = useState(false);

    useEffect(() => {

        fetchGroups();

    }, [user]);

    useEffect(() => {

        renderGroupList();

    }, [groupsData, gotGroups]);

    const fetchGroups = async () => {
        console.log('Fetching groups in section')
        if(!user?.groups) {
            setGotGroups(true);
            return;
        }

        const groupsList = await getFollowingGroups_Helper({ currentUser: user, page_size: PAGE_SIZE });
    
        setGroupsData(groupsList);
        setGotGroups(true);
    }

    const renderGroupList = async () => {
        setGroupsList([]);

        if(!gotGroups) {
            setGroupsList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(groupsData.length > 0) {
                groupsData.map(group_doc => {
                    setGroupsList(groupsList => [...groupsList, (
                        <GroupBlock group_doc={group_doc} />
                    )])
                }) 
            } else {
                setGroupsList(userList => [...userList, (
                    <div className="no-rides">
                        <h1>No groups found</h1>
                    </div>
                )])
                
            }
        } 
    }

    // Don't Render component if there's not data
    if(groupsData.length === 0) return <></>;

    // Render the component
    return (
        <div style={{padding: '16px 0', borderBottom: '1px solid #e6ecf0', width: '100%'}}>
            {/* Section Title */}
            <div style={{padding: '0 16px', color:'rgb(15, 20, 25)', marginBottom: '8px', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>Following</span>
            </div>

            {groupsList?.slice(0, PAGE_SIZE) || []}

            {/* See more btn */}
            {(groupsData.length > 0 && !(groupsData.length < PAGE_SIZE)) && (

                <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                    <div onClick={() => window.location = '/discover/following'} className='see_more_btn full_width'>
                        See all
                    </div>
                </div>
            )}
        </div>
    )
}

// Prop types for the component
FollowingGroupsSection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth,
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(FollowingGroupsSection);
